//try this https://betterprogramming.pub/loading-third-party-scripts-dynamically-in-reactjs-458c41a7013d
import React from "react";
import {graphql} from "gatsby";
import styled from "styled-components";
import {GatsbyImage} from "gatsby-plugin-image";

import PageLayout from "@acc-monorepo/gatsby-stories-acc/national/layout/PageLayout";
import HeadSeo from "@acc-monorepo/gatsby-stories/seo/HeadSeo";
import {Section, NarrowContainer} from "@acc-monorepo/gatsby-stories-acc/national/style/national";
import VimeoVideo from "@acc-monorepo/gatsby-stories/video/VimeoVideo";
import {VideoGrid} from "@acc-monorepo/gatsby-stories/video/VideoGrid";
import Button from "@acc-monorepo/gatsby-stories-acc/buttons/Button";

import DESchoolLinkGrid from "../../components/DESchoolLinkGrid";
import TickIcon from "../../components/icons/Tick";
import CrossIcon from "../../components/icons/Cross";
import DEComparisonTable from "../../components/DEComparisonTable";
import {DEFeatureSection} from "../../components/DEFeatureSection";


const VideoRow = styled(VideoGrid)`
  .video {
    width: 100%;
    margin: 1rem 0;
  }

  .video h2 {
    margin-top: .5rem;
  }

  @media only screen and (min-width: 768px) {
    justify-content: space-between;
    align-items: end;

    .video {
      width: calc(50% - 1rem);
    }
  }
`

// const BlockQuote = styled.blockquote`
//   //font-size: 1.4em;
//   width: calc(100% - 2rem);
//   margin: 1rem auto;
//   font-style:italic;
//   //color: #555555;
//   padding: 1rem 2rem 1rem 4rem;
//   border-left: 4px solid var(--midgrey) ;
//   line-height: 1.6;
//   position: relative;
//   background: var(--white);
//
//   ::before {
//     font-family: Arial;
//     content: "\\201C";
//     color: var(--midgrey);
//     font-size: 4em;
//     position: absolute;
//     left: 10px;
//     top: -10px;
//   }
//
//   .quote-source {
//     display: block;
//     font-style: normal;
//     font-weight: bold;
//     margin-top: 1em;
//   }
// `


const OnlineSchoolPage = (props) => {
  return (
    <PageLayout>
      <DEFeatureSection>
        <GatsbyImage
          image={props.data.backgroundImage.childImageSharp.gatsbyImageData}
          alt="Secondary Student learning through Online School"
          objectPosition="50% 0%"
          loading="eager"
        />
        <NarrowContainer className="content">
          <h1>Online School: The Contemporary Face of Distance Learning</h1>
          <p>
            Online School through Australian Christian College Distance Education offers unparalleled flexibility in today's dynamic world. English on the porch, Math in the morning. Work where it suits you.
          </p>
          <div className="cta-stack">
            <Button href="https://www.acc.edu.au/moreton/distance-education/">Moreton (Qld)</Button>
            <Button href="https://www.acc.edu.au/marsdenpark/distance-education/">Marsden Park (NSW)</Button>
            <Button href="https://www.acc.edu.au/victoria-online/">Victoria (Vic)</Button>
            <Button href="https://www.acc.edu.au/southlands/distance-education/">Southlands (WA)</Button>
            <Button href="https://www.acc.edu.au/launceston/distance-education/">Launceston (Tas)</Button>
          </div>
        </NarrowContainer>
      </DEFeatureSection>

      <Section>
        <NarrowContainer>
          <p>
            School of the Air and Home Schooling laid the groundwork for students learning from wherever they were. Fast forward to today, and we see the emergence of 'online school' - the next generation in the evolution of remote learning. Online school, (also referred to as Distance Education), builds on its core principles while enhancing them with increased interactivity and convenience.
          </p>
          <p>
            In an 'online school', learning is no longer just about watching lessons. Students actively engage with their teachers, participate in lively discussions with peers, and take exams, all from the convenience of their homes. Think of it as blending the best of traditional schooling with the convenience, practicality and ease of life at home. All tailored to the emergence of this current digital age.
          </p>

          {/* VIDEOS */}
          <VideoRow>
            <div className="video">
              <h2 className="h5" id="primary-school-demo">Online Primary School Demo</h2>
              <VimeoVideo
                videoId="681632732"
                title="Online Primary School Demo"
                size="small"
              />
            </div>
            <div className="video">
              <h2 className="h5" id="day-in-the-life-of-a-secondary-student">Day in the life of a Secondary Online Student</h2>
              <VimeoVideo
                videoId="493590982"
                title="Day in the life of a Secondary Online Student"
                size="small"
              />
            </div>
          </VideoRow>
        </NarrowContainer>
      </Section>

      {/* TABLE */}
      {/* Added the visually hidden text for screen readers */}
      <Section>
        <NarrowContainer>
          <DEComparisonTable>
            <ul>
              <li className="question">&nbsp;</li>
              <li className="title"><p>Regular School</p></li>
              <li className="title"><p>Online School</p></li>
              <li className="title"><p>Home School</p></li>
            </ul>
            <ul>
              <li className="question"><p>Do I have to register with the government as a homeschooler?</p></li>
              <li className="answer"><span className="visually-hidden">regular school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">online school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">home school: </span><TickIcon/></li>
            </ul>
            <ul>
              <li className="question"><p>Do I have visits from government moderators?</p></li>
              <li className="answer"><span className="visually-hidden">regular school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">online school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">home school: </span><TickIcon/></li>
            </ul>
            <ul>
              <li className="question"><p>Do I have to create or buy a learning program that meets the Australian Curriculum Standards?</p></li>
              <li className="answer"><span className="visually-hidden">regular school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">online school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">home school: </span><TickIcon/></li>
            </ul>
            <ul>
              <li className="question"><p>Is my child taught by qualified teachers through a registered school?</p></li>
              <li className="answer"><span className="visually-hidden">regular school: </span><TickIcon/></li>
              <li className="answer"><span className="visually-hidden">online school: </span><TickIcon/></li>
              <li className="answer"><span className="visually-hidden">home school: </span><CrossIcon/></li>
            </ul>
            <ul>
              <li className="question"><p>Do I have to keep records of lessons, learning progress, time allocations and assessments?</p></li>
              <li className="answer"><span className="visually-hidden">regular school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">online school: </span><CrossIcon/></li>
              <li className="answer"><span className="visually-hidden">home school: </span><TickIcon/></li>
            </ul>
            <ul>
              <li className="question"><p>Am I part of a registered school?</p></li>
              <li className="answer"><span className="visually-hidden">regular school: </span><TickIcon/></li>
              <li className="answer"><span className="visually-hidden">online school: </span><TickIcon/></li>
              <li className="answer"><span className="visually-hidden">home school: </span><CrossIcon/></li>
            </ul>
          </DEComparisonTable>
        </NarrowContainer>
      </Section>

      {/* GRID PREAMBLE */}
      <Section>
        <NarrowContainer>
          <p>
            Five Australian Christian Colleges are registered to deliver school fully online. Collectively, they are Australia’s largest non-government distance education provider. They provide an online education to students living in Queensland, New South Wales, Victoria, Western Australia and Tasmania with appropriate matriculation options upon graduation.
          </p>
          <p>
            Different states impose different eligibility requirements for online enrolments, and so it’s important to check your child’s eligibility with the distance education providers in your state.
          </p>
        </NarrowContainer>
      </Section>

      <Section id="student-videos" style={{backgroundColor: "var(--offwhite)"}}>
        <NarrowContainer>
          <h2 id="DE-student-stories">Online Distance Education Student Stories</h2>

          <p>
            ACC Online Distance Education (DE) suits a diversity of students. Our Online Distance education student stories highlight a small selection of students, showcasing how ACC DE is meeting their individual needs and enabling them to pursue their specific goals. </p>
          {/*<BlockQuote>*/}
          {/*  In grade 10 I decided to choose online school as my workload and swimming were both increasing… I haven’t regretted it!*/}
          {/*  <span className="quote-source">Esther Davies</span>*/}
          {/*</BlockQuote>*/}
          <p>
            <i>
              <q>In grade 10 I decided to choose online school as my workload and swimming were both increasing… I haven’t regretted it!</q> - <b>Esther Davies</b>
            </i>
          </p>
          <p>
            Esther is a national champion swimmer from Queensland who is also a high achieving academic student. She wanted to continue achieving in both areas.
          </p>
          <p>
            Online School allows her to complete her school work around her rigorous training schedule without compromising on either.
          </p>
          {/*<h3 style={{fontFamily: "Born Ready, Montserrat, sans-serif", letterSpacing: "0.1em", fontStyle: "italic", fontWeight: "600"}}>DE Student Stories: Meet Esther</h3>*/}
          <VimeoVideo videoId={857709643} size="large" lazy/>
          {/*<VideoSlider videos={[*/}
          {/*  {id: '493629813', title: 'Students living overseas learn with ACC Distance Education'},*/}
          {/*  {id: '500715212', title: 'Naomi ranked in the top 1% in Australia learning through DE'},*/}
          {/*  {id: '493633194', title: 'Professional wakeboarder Mikayo appreciates the flexibility of DE'},*/}
          {/*  {id: '493630653', title: 'Moe completed her Japanese and Queensland leaving certificates concurrently'}*/}
          {/*]} style={{marginBottom: '3rem'}} />*/}
        </NarrowContainer>
      </Section>

      {/* GRID */}
      <Section>
        <NarrowContainer>
          <p>
            We also refer to Online School as Distance Education. You can learn more about our online platform by selecting the provider in your state.
          </p>
          <DESchoolLinkGrid/>
        </NarrowContainer>
      </Section>

      {/* BUTTONS */}
      <Section>
        <NarrowContainer>
          <p>You might also like to read:</p>
          <Button href="https://www.acc.edu.au/blog/everything-you-need-to-know-about-distance-education/">Everything you need to know about Distance Education</Button>
          <Button href="https://www.acc.edu.au/eguides/the-definitive-guide-to-distance-education">The definitive guide to distance education</Button>
        </NarrowContainer>
      </Section>

    </PageLayout>
  )
}

export default OnlineSchoolPage

export function Head() {
  return (
    <HeadSeo
      title="Online School"
      description="Explore Flexible Online Schooling with Australian Christian College. Learn from home with engaging classes, interactive learning, and qualified teachers. Join us in shaping the future of education."
      schema={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
          "@type": "Question",
          "name": "Do I have to register with the government as a homeschooler?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Regular school: No. Online school: No. Home school: Yes."
          }
        }, {
          "@type": "Question",
          "name": "Do I have visits from government moderators?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Regular school: No. Online school: No. Home school: Yes."
          }
        }, {
          "@type": "Question",
          "name": "Do I have to create or buy a learning program that meets the Australian Curriculum Standards?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Regular school: No. Online school: No. Home school: Yes."
          }
        }, {
          "@type": "Question",
          "name": "Is my child taught by qualified teachers through a registered school?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Regular school: Yes. Online school: Yes. Home school: No."
          }
        }, {
          "@type": "Question",
          "name": "Do I have to keep records of lessons, learning progress, time allocations and assessments?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Regular school: No. Online school: No. Home school: Yes."
          }
        }, {
          "@type": "Question",
          "name": "Am I part of a registered school?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Regular school: Yes. Online school: Yes. Home school: No."
          }
        }]
      }}
    />
  )
}

export const query = graphql`
  query {
    backgroundImage:  file(relativePath: {eq: "images/distance-education/distance-education-feature.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: BLURRED
          formats: [AUTO, WEBP, AVIF]
          quality: 95
        )
      }
    }
  }
`
